import React, { useMemo } from 'react';
import { FlatList } from 'react-native';
import { createStyleSheet, Divider, useStyleSheet, Loader, View } from '@gopeerproject/ui-kit';
import { Row } from './Row';
export const Table = ({ data, columns, style, dimensions, minColumnWidth, alignment, onItemPress, isLoading, onEndReached, selector, selected, setSelected }) => {
    const styles = useStyleSheet(getStyles);
    const selectedSet = useMemo(() => new Set(selected), [selected]);
    return isLoading ? (React.createElement(View, { style: { flex: 1 } },
        React.createElement(Loader, { full: true }))) : (React.createElement(FlatList, { style: style, contentContainerStyle: styles.content, ListHeaderComponent: () => (React.createElement(React.Fragment, null,
            React.createElement(Row, { data: columns.map((v) => ({ type: 'text', value: v.value })), dimensions: dimensions, minColumnWidth: minColumnWidth, cellTextStyle: styles.header__cell, alignment: alignment, selector: selector, selected: (selected === null || selected === void 0 ? void 0 : selected.length) === data.length, onSelectChange: (value) => {
                    if (!value) {
                        setSelected === null || setSelected === void 0 ? void 0 : setSelected([]);
                        return;
                    }
                    setSelected === null || setSelected === void 0 ? void 0 : setSelected(data.map(({ id }) => id));
                } }),
            React.createElement(Divider, { type: 'horizontal', style: styles.divider }))), ItemSeparatorComponent: () => (React.createElement(Divider, { type: 'horizontal', style: styles.divider })), data: data, keyExtractor: (item) => item.id.value, renderItem: ({ item }) => {
            const id = item.id.value;
            return (React.createElement(Row, { key: id, data: columns.map(({ key }) => item[key]), dimensions: dimensions, minColumnWidth: minColumnWidth, alignment: alignment, onPress: () => {
                    onItemPress === null || onItemPress === void 0 ? void 0 : onItemPress(item);
                }, selector: selector, selected: selectedSet.has(id), onSelectChange: (value) => {
                    setSelected === null || setSelected === void 0 ? void 0 : setSelected((cur) => value ? [...cur, id] : cur.filter((i) => i !== id));
                } }));
        }, onEndReached: onEndReached }));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: { flex: 1 },
    header__cell: {
        color: color.invert2.p68
    },
    content: {
        paddingBottom: size.G
    },
    divider: {
        marginHorizontal: size.E
    }
}));
//# sourceMappingURL=index.js.map